export const AboutData = [
  "I'm Umesh Verma and I am currently living in Bengaluru, India working at Harman as an iOS Engineer",
  "In 2015, I graduated from the UPTU in India with a bachelor degree in Computer Science and Engineering.",
  "After my studies I worked as a full-time Software Engineer at Web Spiders where I built various projects related to the iOS.",
  "Developing iOS apps has been my big passion for the last 6 years. I experiment a lot with every technology that is available to me.",
  "Take a look at my blog, follow me on Twitter or feel free to contact me via email.",
];
